import { MARK_ALL_ISSUE_NOTES_READ } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case MARK_ALL_ISSUE_NOTES_READ.LOAD:
      return {
        ...state,
        loading: true,
      };
    case MARK_ALL_ISSUE_NOTES_READ.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case MARK_ALL_ISSUE_NOTES_READ.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
